/**
 * 给定 URL, 返回一个 window.URL 实例
 * @param url
 * @returns {*|URL}
 */
export function parseUrl(url: string) {
  if (url.startsWith('//')) {
    url = window.location.protocol + url;
  }
  return new window.URL(url);
}

/**
 * 获取 URL 中的参数
 * @param name 为参数名
 * @param url 为获取参数的URL
 */
export function getUrlParam(name: string, url = window.location.href) {
  return parseUrl(url).searchParams.get(name);
}

/**
 * 删除 URL 中参数
 * @param name 为参数名
 * @returns {String}
 */
export function removeUrlParam(name: string, url = window.location.href) {
  let obj = parseUrl(url);
  obj.searchParams.delete(name);
  return obj.href;
}

/**
 * 增加 URL 中的参数
 * @param key
 * @param value
 * @param url
 * @returns {String}
 */
export function addUrlParam(key: string, value: any, url = window.location.href) {
  let obj = parseUrl(url);
  obj.searchParams.set(key, value);
  return obj.href;
}

/**
 * 获取 URL 里 domain
 * 举例: url = "http://jira.yqxiu.cn/browse/REFACT-17"
 * 返回 "jira.yqxiu.cn"
 */
export function getUrlHost(url = window.location.href) {
  return parseUrl(url).host;
}

/**
 * 返回 URL 的 pathName
 * @param url
 */
export function getPathName(url = window.location.href) {
  var obj = parseUrl(url);
  return obj.pathname;
}
